/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_Pricing_Compare_Credits_FreeInputs */

const en_landing_pricing_compare_credits_free = /** @type {(inputs: Landing_Pricing_Compare_Credits_FreeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`5 on signup`)
};

const zh_landing_pricing_compare_credits_free = /** @type {(inputs: Landing_Pricing_Compare_Credits_FreeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`注册送 5 次`)
};

/**
* | output |
* | --- |
* | "5 on signup" |
*
* @param {Landing_Pricing_Compare_Credits_FreeInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const landing_pricing_compare_credits_free = /** @type {((inputs?: Landing_Pricing_Compare_Credits_FreeInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Pricing_Compare_Credits_FreeInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_landing_pricing_compare_credits_free(inputs)
	return zh_landing_pricing_compare_credits_free(inputs)
});
export { landing_pricing_compare_credits_free as "landing.pricing.compare_credits_free" }